import AppController from 'controllers/app';

// Initialise Application
window.App = new AppController();


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/app.js